import React, { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import ProfessionalHeader from '../components/ProfessionalHeader';
import BasicRecommendationForm from '../components/BasicRecommendationForm';
import RecommendationResults from '../components/RecommendationResults';
import { UserCriteria, RecommendationResponse, getRecommendations } from '../services/recommendationService';

const QuickRecommendationPage: React.FC = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [recommendationResults, setRecommendationResults] = useState<RecommendationResponse | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleRecommendationSubmit = useCallback(async (criteria: UserCriteria) => {
    console.log('🚀 Quick: handleRecommendationSubmit called with:', criteria);
    setLoading(true);
    setError(null);

    try {
      const response = await getRecommendations(criteria);
      console.log('✅ Quick: Got response, setting results');
      setRecommendationResults(response);
    } catch (err: any) {
      console.error('❌ Quick: Error in recommendation flow:', err);
      setError(err.message || 'Failed to get recommendations. Please try again.');
    } finally {
      setLoading(false);
    }
  }, []);

  const handleBackToSelector = useCallback(() => {
    navigate('/');
  }, [navigate]);

  const handleBackToForm = useCallback(() => {
    setError(null);
    setRecommendationResults(null);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <ProfessionalHeader user={user} onLogout={logout} />
      <main className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div>
          <button
            onClick={recommendationResults ? handleBackToForm : handleBackToSelector}
            className="mb-6 text-green-ink hover:text-green-ink font-medium flex items-center"
          >
            {recommendationResults ? '← Back to Form' : '← Back to Selection'}
          </button>

          <div className="text-center mb-6">
            <h2 className="text-2xl font-bold text-gray-900">Quick Equipment Recommendations</h2>
            <p className="text-gray-600 mt-2">Fast recommendations based on basic information</p>
          </div>

          {recommendationResults ? (
            <RecommendationResults
              results={recommendationResults}
              loading={loading}
              error={error}
              onBack={handleBackToForm}
              className=""
            />
          ) : (
            <BasicRecommendationForm
              onSubmit={handleRecommendationSubmit}
              loading={loading}
              className=""
            />
          )}
        </div>
      </main>
    </div>
  );
};

export default QuickRecommendationPage;
